<template>
  <div class="search">
    <router-link to="/">
      <h2>Movie Search</h2>
    </router-link>
   <DataSearch
      :componentId="id"
      :dataField="['original_title', 'original_title.keyword' , 'original_title.search', 'original_title.keyword']"
      :autosuggest="true"
      placeholder="Search Movie"
      :showIcon="true"
      iconPosition="right"
      :innerClass="{
        input: 'search-input',
        list: 'search-list'
      }"
      @valueChange="updateSelected"
      :URLParams="true"
    />
     <Navigation :selected="selected"/>
  </div>
</template>;

<script>
import Navigation from './Navigation'

export default {
  name: 'Search',
  props: {
    id:{
      required: true
    }
  },
  data(){
    const init = this.$route && this.$route.query && this.$route.query[this.id];
    return {
      selected: init
    }
  },
  components: {
    Navigation
  },
  methods:{
    updateSelected: function(value){
      this.selected = `"${value}"`;
    }
  }
}
</script>